import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import Language from "../mod/language";

function Aside({ asideToggle, setAsideOpen, logo }) {
const handleClose = () => setAsideOpen(false);
const [showLanguage, setShowLanguage] = useState(false);
const [activeCategory, setActiveCategory] = useState("");
const [systems, setSystems] = useState([]);
const [isLoggedIn, setIsLoggedIn] = useState(false);
const navigate = useNavigate();
// Build baseDomain and retain original TLD chain for affiliate & APK naming
const hostname = window.location.hostname.toLowerCase();
const tldParts = ["com","in","live","net","org","co","io","app","dev","cloud","site","vip"];
const originalSegs = hostname.replace(/^www\./,'').split('.');
const segs = [...originalSegs];
const poppedTlds = [];
while (segs.length > 1 && tldParts.includes(segs[segs.length - 1])) {
  poppedTlds.unshift(segs.pop()); // keep original order (e.g. co.in)
}
const baseDomain = segs[segs.length - 1];
const tldSuffix = poppedTlds.join('.');
const affiliateDomain = `affilaite.${baseDomain}${tldSuffix ? '.' + tldSuffix : ''}`;
    useEffect(() => {
      // 🔍 check token from localStorage
      const token = localStorage.getItem("token");
      if (token && token !== "null" && token !== "undefined") {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    }, []);

      const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    window.location.href = '/';
  };
  const menuItems = [
  { type: "LIVE", icon: "/static/svg/mobileMenu/ld.svg", title: "Live casino" },
  { type: "SLOT", icon: "/static/svg/mobileMenu/rng.svg", title: "Slot games" },
  { type: "TABLE", icon: "/static/svg/mobileMenu/table.svg", title: "Table Games" },
  { type: "EGAME", icon: "/static/svg/mobileMenu/crash.svg", title: "Crash"},
  { type: "BINGO", icon: "/static/svg/mobileMenu/sb.svg", title: "Pocker" },
  { type: "FH", icon: "/static/svg/mobileMenu/fishing.svg", title: "Fishing" },
];
const providerData = [{ platform: "icon-all-provider.svg" }];

    const handleCasinoClick = (type) => {
        const selectedMenu = menuItems.find(item => item.type === type);
          if (menuItems) {
        const { title } = selectedMenu;
        navigate(`/games?type=${type}&system=ALL&title=${encodeURIComponent(title)}`);
        } else {
            console.error('Selected menu item not found');
        }
    };

  return (
<>
    
    <aside className={`mobile-navigation-drawer v-navigation-drawer v-navigation-drawer--absolute v-navigation-drawer--is-mobile v-navigation-drawer--temporary theme--dark ${asideToggle ? 'v-navigation-drawer--open' : 'v-navigation-drawer--close'}`} left data-booted="true" style={{height: '100%', top: '0px', transform: `translateX(${asideToggle ? '0%' : '-100%'})`, width: '256px',  zIndex: 10,}}>
       <div className="v-navigation-drawer__content">
  <div className="row">
    <div className="mobile-drawer-menu-header-section col col-12">
      <a  className="mobile-drawer-menu-logo router-link-exact-active router-link-active"><img src={logo} alt="" width={215} height={30} className="mt-4" /></a>
      <button onClick={handleClose} type="button" className="v-icon notranslate mobile-drawer-menu-icon v-icon--link mdi mdi-menu theme--dark" />
    </div>
  </div>
  <hr role="separator" aria-orientation="horizontal" className="my-4 mx-4 v-divider theme--dark" />
  <div role="list" className="v-list pb-16 mobileMenuListItem v-sheet theme--dark v-list--dense v-list--nav">
    <div role="listbox" className="v-item-group theme--dark v-list-item-group">
      <Link to="/promotion" className="v-list-item v-list-item--link theme--dark" tabIndex={0} role="option" aria-selected="false">
        <div className="v-list-item__icon"><img src="./static/svg/mobileMenu/promotion.svg" alt="" width={25} height={25} /></div>
        <div className="v-list-item__content"><div className="v-list-item__title">Promotion</div></div>
      </Link>
      <Link to="/vip" className="menu-item-1 v-list-item v-list-item--link theme--dark" tabIndex={0} role="option" aria-selected="false">
      <div className="v-list-item__icon"><img src="/static/svg/mobileMenu/vip.svg" alt="" width={25} height={25} /></div>
      <div className="v-list-item__content"><div className="v-list-item__title list-item-title">VIP</div></div>
    </Link>
    <a tabIndex={0} href={`https://${affiliateDomain}/login`} target="_blank" role="option" aria-selected="false" className="v-list-item v-list-item--link theme--dark">
        <div className="v-list-item__icon"><img src="./static/svg/mobileMenu/agentAff.svg" alt="" width={25} height={25} /></div>
        <div className="v-list-item__content"><div className="v-list-item__title">Agent Affiliate</div></div>
      </a>

      <hr role="separator" aria-orientation="horizontal" className="my-4 mx-4 v-divider theme--dark" />
        <span class="mobile-drawer-itemgroup-title">Games</span>
        <div role="listbox" className="v-item-group theme--dark v-list-item-group">
  {menuItems.map((item, index) => (
  <a onClick={() => handleCasinoClick(item.type )}  className="v-list-item v-list-item--link theme--dark" tabIndex={0} role="option" aria-selected="false">
    <div className="v-list-item__icon"><img src={item.icon} alt={item.title} width={25} height={25} /></div>
    <div className="v-list-item__content">
      <div className="v-list-item__title">
        <div className="row no-gutters align-center justify-start">
          <div className="mt-1 col col-auto">{item.title}</div>
          {/**/}
        </div>
      </div>
    </div>
  </a>
  ))}
 
</div>

      
     
    
    
      
    </div>
   
   
    <hr role="separator" aria-orientation="horizontal" className="my-4 mx-4 v-divider theme--dark" />
    <span className="mobile-drawer-itemgroup-title">Others</span>
    <div role="listbox" className="v-item-group theme--dark v-list-item-group">
      <div tabIndex={0} role="option" aria-selected="false" className="v-list-item v-list-item--link theme--dark" onClick={() => setShowLanguage(true)} style={{cursor: 'pointer'}}>
        <div className="v-list-item__icon">
          <button type="button" className="v-btn v-btn--icon v-btn--round theme--dark v-size--small" style={{marginLeft: '-3px'}}>
            <span className="v-btn__content">
              <div className="v-avatar language-button" style={{height: '25px', minWidth: '25px', width: '25px'}}><img src="./static/svg/mobileMenu/language.svg" /></div>
            </span>
          </button>
        </div>
        <div className="v-list-item__content"><div className="v-list-item__title">Language</div></div>
      </div>
    
      <a href={`./app/${baseDomain}.apk`} tabIndex={0} role="option" aria-selected="false" className="v-list-item v-list-item--link theme--dark">
        <div className="v-list-item__icon">
          <button type="button" className="v-btn v-btn--icon v-btn--round theme--dark v-size--small" style={{marginLeft: '-3px'}}>
            <span className="v-btn__content">
              <div className="v-avatar" style={{height: '25px', minWidth: '25px', width: '25px'}}><img src="./static/svg/mobileMenu/downloadApp.svg" /></div>
            </span>
          </button>
        </div>
        <div className="v-list-item__content"><div className="v-list-item__title">Download App</div></div>
      </a>
    </div>
    <hr role="separator" aria-orientation="horizontal" className="my-4 mx-4 v-divider theme--dark" />
        {isLoggedIn &&(
             <div onClick={handleLogout} role="listbox" className="v-item-group theme--dark v-list-item-group">
    <div tabIndex={0} role="option" aria-selected="false" className="v-list-item v-list-item--link theme--dark">
      <div className="v-list-item__icon"><img src="./static/svg/mobileMenu/logout.svg" alt="" width={25} height={25} /></div>
      <div className="v-list-item__content"><div className="v-list-item__title">Logout</div></div>
    </div>
  </div>
        )}
     

  </div>
</div>

        <div className="v-navigation-drawer__border" />
      </aside>
      {showLanguage && (
        <Language onClose={() => setShowLanguage(false)} />
      )}
      <div
        className="v-overlay v-overlay--active theme--dark"
        onClick={handleClose}
        style={{
          zIndex: 7,
        }}
       
      >
        <div
          className="v-overlay__scrim"
          style={{
            opacity: "0.46",
            backgroundColor: "rgb(33, 33, 33)",
            borderColor: "rgb(33, 33, 33)",
            height: "100vh",
            width: "100vw",
          }}
        />
      </div>
</>
  );
}
export default Aside;